import { useMutation, useQueryClient } from '@tanstack/react-query';
import { invalidateContactAvatarCaches } from '@/entities/contact/model/contacts.hook';
import type { UpdateOwnProfileParams } from '../api/users.api';
import { updateOwnProfile } from '../api/users.api';
import { withGlobalErrorHandling } from '@/shared/lib/query-client';

export function useUpdateOwnProfile() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (params: UpdateOwnProfileParams) => updateOwnProfile(params),
        onSuccess: updatedContact => {
            invalidateContactAvatarCaches(queryClient, updatedContact.contactId);
        },
        ...withGlobalErrorHandling(),
    });
}
